// extracted by mini-css-extract-plugin
export default {"container":"g0pFfSeFxxIO9rkATnQn","infoGroup":"M7Tj67n3sKYOIkcCGxvX"};